import { loadStripe } from '@stripe/stripe-js'

// Get Stripe publishable key from environment variables
const stripePublishableKey = (import.meta as any).env?.VITE_STRIPE_PUBLISHABLE_KEY

if (!stripePublishableKey) {
  console.error('VITE_STRIPE_PUBLISHABLE_KEY is not set in environment variables')
}

// Make sure to call loadStripe outside of a component's render to avoid
// recreating the Stripe object on every render.
export const stripePromise = loadStripe(stripePublishableKey)

// Plan configurations with Stripe price IDs
// Note: Replace these price IDs with actual ones from your Stripe dashboard
export const stripePlans = {
  freemium: {
    id: 'freemium',
    name: 'Freemium',
    price: 0,
    priceId: null, // No Stripe price ID for free plan
    interval: 'forever'
  },
  professional: {
    id: 'professional',
    name: 'Professional',
    price: 2900, // $29.00 in cents
    priceId: process.env.STRIPE_PROFESSIONAL_PRICE_ID || 'price_1RT7MNASx0CoTWWTcKCW6ru8', // Replace with actual Stripe price ID
    interval: 'month'
  },
  studio: {
    id: 'studio',
    name: 'Studio',
    price: 9900, // $99.00 in cents
    priceId: process.env.STRIPE_STUDIO_PRICE_ID || 'price_1RT7MwASx0CoTWWTS6xj46YL', // Replace with actual Stripe price ID
    interval: 'month'
  }
}

// Helper function to format price
export const formatPrice = (priceInCents: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(priceInCents / 100)
}

// Helper function to get plan by ID
export const getPlanById = (planId: string) => {
  return stripePlans[planId as keyof typeof stripePlans] || stripePlans.freemium
} 